import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default  class TickXiQ extends Component {
    constructor(props) {
        super(props);

        (function(t, i, c, k, x) {
            if (!t.txtp) {
              t.txtp = [];
              t.txt = function(c) { t.txtp.push(c); }
            }
            x = i.createElement(c);
            x.id = 'tickXpixel' + new Date().getTime().toString();
            x.src = 'https://widgets.tickxiq.com/js/' + (Date.now()) + '/' + k + '/pixel.js';
            const e = i.getElementsByTagName(c)[0];
            e.parentNode.insertBefore(x, e);
        })(window, document, 'script', props.config.id);
    }

    render() {
        return null;
    }
}

TickXiQ.propTypes = {
    config: PropTypes.object.isRequired,
}
